import { MouseEvent } from 'react';
import styled from 'styled-components';
import {
  Icon,
  FlexGrow,
  useIsAuth,
  Flex,
  Header as HeaderShared,
} from '@equifinance/shared';

export const HeaderControls = styled(Flex)`
  gap: ${({ theme }) => theme.padding[6]};
  align-items: center;
`;

export const HeaderIcon = styled(Icon)` ${({ theme }) => `
  color: ${theme.colours.neutral[10]};
  font-size: ${theme.fontSize[5]};
`}`;

function Header({ onClickLogo }:{ onClickLogo?: (event?: MouseEvent<HTMLElement>) => void }) {
  const isAuth = useIsAuth();
  return (
    <HeaderShared onClickLogo={onClickLogo}>
      {isAuth && (
      <>
        <FlexGrow />
        <HeaderControls />
      </>
      )}
    </HeaderShared>
  );
}

export default Header;
